import { Component } from '@angular/core';

@Component({
  selector: 'kng-panel',
  templateUrl: './kng-panel.component.html',
  styleUrls: []
})
export class KngPanel {

  public open: boolean = true;

  constructor() { }

  closePanel() {
    this.open = false;
    console.log('this.open', this.open);
  }

  toggle() {
    this.open = ! this.open;
  }

  isOpen() {
    return this.open === true;
  }

  openPanel() {
    this.open = true;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-panel/kng-panel.component.ts